import { useEffect } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const PricingPage = () => {
  const embedId = "kGjpThGcjgM";

  const getIconUrl = () => {
    return;
  };

  useEffect(() => {
    document.title = "Daly Exercise+ | Pricing";
  }, []);
  return (
    <Container className="full-page-length" fluid>
      <div className="purple-body">
        <h1 className="pricing-title">Daly Exercise+ Pricing</h1>
        <div className="pricing-subtext">
          <br />
          All of our subscription options come with a{" "}
          <b className="orange-text">week free trial</b>. Allowing you and your
          school to try out <b className="orange-text">Daly Exercise+</b>!
          <br />
          <br />
        </div>
      </div>
      <div className="white-body gray-bg">
        <Container>
          <Row>
            <Col sm={6} className="">
              <Row className="pricing-card-1 mb-1">
                <Col sm={6} className="d-flex align-items-center">
                  <img
                    src="/icons/icon_athletics_single.png"
                    className="pricing-image"
                    alt="Individual Subscription Icon"
                  ></img>
                </Col>
                <Col sm={6}>
                  <h3 className="pricing-heading">Individual Subscription</h3>
                  <br />
                  <div className="">
                    Subscribe to get access to over 500 custom lessons, movement
                    breaks, and homework exercises!
                  </div>
                  <br />
                  <div className="pricing-text">
                    <b>
                      €3.00 per month or <br />
                      €25.00 per year
                    </b>
                  </div>
                  <br />
                  <Link to={`/register/teacher`} className="text-link">
                    <div className="d-flex justify-content-center">
                      <Button
                        variant="primary"
                        className="main-button-green button-padding"
                      >
                        Sign Up
                      </Button>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col sm={6} className="justify-content-center ">
              <Row className="pricing-card-2">
                <Col sm={6} className="d-flex align-items-center">
                  <img
                    src="/icons/icon_athletics.png"
                    className="pricing-image"
                    alt="School Subscription Icon"
                  ></img>
                </Col>
                <Col sm={6}>
                  <h3 className="pricing-heading"> School Subscription</h3>
                  <br />
                  <div className="">
                    Get access for your whole school! Sign up as an admin and
                    add your teachers!
                  </div>
                  <br />
                  <div className="pricing-text">
                    <b>
                      €25.00 per person
                      <br /> per year
                    </b>
                  </div>
                  <br />
                  <Link to={`/register/teacher`} className="text-link">
                    <div className="d-flex justify-content-center">
                      <Button
                        variant="primary"
                        className="main-button-yellow button-padding"
                      >
                        Sign Up
                      </Button>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="blue-body">
        <h3 className="pricing-subtitle text-white">Ready to Get Started?</h3>

        <div className="pricing-subtext text-center m-auto">
          <br />
          Sign up for a plan that suits you best, and unlock a free week to
          explore all the features Daly Exercise+ has to offer. Transform your
          P.E. classes today!
        </div>
        <br />
        <br />
        <Link to={`/register/teacher`} className="text-link">
          <div className=" text-center">
            <Button variant="primary" className="pricing-button button-padding">
              Start Your Free Trial
            </Button>
          </div>
        </Link>
      </div>
    </Container>
  );
};

export default PricingPage;
